import { render, staticRenderFns } from "./edit-logistic.vue?vue&type=template&id=3d1f14f9&"
import script from "./edit-logistic.vue?vue&type=script&lang=js&"
export * from "./edit-logistic.vue?vue&type=script&lang=js&"
import style0 from "./edit-logistic.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports